export function axiosInterceptors(axios) {
	axios.interceptors.response.use(
		(response) => {
			const statusCode =
				response?.headers?.['x-status-code'] || response?.headers?.['X-Status-Code']

			if (statusCode && Number.parseInt(statusCode) > 299) {
				// We actually have an error
				const data = {
					response: {
						...response,
						status: Number.parseInt(statusCode),
					},
				}
				return Promise.reject(data)
			}

			return response
		},
		(error) => {
			return Promise.reject(error)
		}
	)
}
